var form = {
    urlParams: '',
    apiUrl: api.url,
    selectVille: '',
    selectFormation: '',
    selectDates: '',
    query: window.location.search,
    elements: object,
    formations: [],
    ville: '',
    formationId: '',
    villesForFormation: [],
    centres: [],
    
    /**
     * Fonction qui débute le script
     */
    init: async function () {
        console.info('INIT contact.js');
        form.urlParams = new URLSearchParams(form.query);
        if (form.elements.args.onCf7) { // Si on est sur la page de formulaire, on a plusieurs select de même type
            form.selectFormation = document.getElementsByName('formation');
            form.selectVille = document.getElementsByName('centre');
            form.selectDates = document.getElementsByName('session');
            form.ville = form.urlParams.get('ville');
            if (form.urlParams.size == 0 && form.elements.args.onPreinscriptionPage) {
                form.selectDates.forEach((selectDate) => {
                    let parent = selectDate.closest('.row');
                    parent.style.display = 'none';
                });
                form.selectVille.forEach((centre) => {
                    let parent = centre.closest('.row');
                    parent.style.display = 'none';
                });
                
                // Fill the inputs for cf7 sending
                form.fillHiddenFields();
            }
        } else { // Si on est sur la page de formation, on a un seul select par type
            form.selectFormation = document.querySelector('select[name="formation"]');
            form.selectVille = document.querySelector('select[name="ville"]');
            form.selectDates = document.querySelector('select[name="sessions"]');
            
            form.changeTarif();
        }

        // DEBUT - On remplit tous les selects précédents
        if (form.elements.args.onCf7) {
   
            // On remplit les selects des formations
            if (form.selectFormation.length > 0) {
                for (let item of form.selectFormation) {
                    let option = document.createElement('option');
                    option.value = '';
                    option.text = "Aucun";
                    item.add(option);
                    await form.populateFormationSelect(item);
                }
            }

            // On remplit les selects des villes de formation
            if (form.selectVille.length > 0) {
                for (let item of form.selectVille) {
                    let option = document.createElement('option');
                    option.value = '';
                    option.text = "Aucun";
                    item.add(option);
                    await form.populateCentreSelect(item);
                }
            }
    
            // On remplit les selects des sessions de formation
            if (form.selectDates.length > 0) {
                await form.updateDates('', form.urlParams.get('ville'), true);
            }
            
            // On sélectionne le bon centre si on a ce paramètre dans l'URL
            form.selectVille.forEach((element) => {
                Array.from(element.options).forEach((option) => {
                    form.updateVilles(option, form.urlParams.get('ville'), true);
                })
            });
        }

        // FIN - On remplit tous les selects précédents

        // Permet de savoir sur quel formulaire on est
        form.getSelectedForm();

        
        // Change the select in preinscription form
        document.addEventListener('change', (e) => {
            if (e.target.closest('.state')) {
                form.setSelectedForm(e);
            }
        });
        
        await form.handleChange();

    },
        
    /**
     * Permet de populer les options du select des formations avec les formations
     * @param {*} select - le formulaire parmi les formulaires de même type
     * @returns 
     */
    populateFormationSelect: async function (select) {

        // On récupère le paramètre de formation dans l'URL si il existe
        if (form.urlParams.get('formation')) {
            form.formationId = form.urlParams.get('formation');
        }

        let page = 1;
        let perPage = 100;
        let totalPages = 1;
        let formations = [];
    
        // On fait un appel à l'API pour récupérer toutes les formations tant qu'il y a de pages de résultats
        do {
            let url = `${form.apiUrl}wp/v2/formations?per_page=${perPage}&page=${page}&orderby=title&order=asc`;
    
            try {
                const response = await fetch(url);
    
                if (!response.ok) {
                    throw new Error(`Erreur de réponse : ${response.status}`);
                }
    
                // Lecture du nombre total de pages à partir des headers
                if (page === 1) {
                    totalPages = parseInt(response.headers.get('X-WP-TotalPages'), 10) || 1;
                }
    
                const data = await response.json();
                formations = formations.concat(data);
            
            } catch (error) {
                console.error("Erreur lors du chargement des formations :", error);
                return;
            }
    
            page++;
        } while (page <= totalPages);

        form.formations = formations;
    
        // Nettoie les options du select
        select.options.length = 0;

        let option = document.createElement('option');
        option.value = 'default';
        option.text = 'Veuillez choisir une formation';
        select.add(option);
    
        // Ajout des options correspondant aux formations
        form.formations.forEach((element) => {
            let option = document.createElement('option');
            option.text = form.decodeHTMLEntities(element.title.rendered);
            option.dataset.formation = element.id;
            select.add(option);
            form.getOptionSelected(option, option.dataset.formation);
        });

    },

    /**
     * Permet de populer les options du select des centre de formation avec les villes de formation
     * @param {*} select - le formulaire parmi les formulaires de même type
     * @returns 
     */
    populateCentreSelect: async function (select) {
        let page = 1;
        let perPage = 100;
        let totalPages = 1;
        let centres = [];
    
        // On fait un appel à l'API pour récupérer touts les villes de formation tant qu'il y a de pages de résultats
        do {
            let url = `${form.apiUrl}wp/v2/villes?per_page=${perPage}&page=${page}&orderby=title&order=asc`;
    
            try {
                const response = await fetch(url);
    
                if (!response.ok) {
                    throw new Error(`Erreur de chargement des centres : ${response.status}`);
                }
    
                if (page === 1) {
                    totalPages = parseInt(response.headers.get('X-WP-TotalPages'), 10) || 1;
                }
    
                const data = await response.json();
                centres = centres.concat(data);
                
            } catch (error) {
                console.error("Erreur lors du chargement des villes :", error);
                return;
            }
    
            page++;
        } while (page <= totalPages);
    

        form.centres = centres;
        // Vider le select avant d’ajouter les nouvelles options
        select.options.length = 0;

        let option = document.createElement('option');
        option.value = '';
        option.text = 'Veuillez choisir une ville de formation';
        select.add(option);
    
        // Ajout des options correspondant aux villes de formation
        form.centres.forEach((element) => {
            if (element && element.title && element.title.rendered) {
                let option = document.createElement('option');
                option.value = element.id;
                option.text = form.decodeHTMLEntities(element.title.rendered);
                select.add(option);
                form.getOptionSelected(option, option.value);
                form.villesForFormation.push(element.id);
            }
        });
    },
    
    /**
     * Retourne la date formatée
     * @param {*} dateStr - date au format JJMMAAAA
     * @returns 
     */
    formatDate: function(dateStr) {
        // Extraire les parties de la date
        let year = dateStr.substring(0, 4);
        let month = dateStr.substring(4, 6);
        let day = dateStr.substring(6, 8);

        // Formater la date en JJ/MM/AAAA
        return `${day}/${month}/${year}`;
    },

    /**
     * Sélectionne la bonne option dans le select au chargement de la page si le paramètre est présent dans l'URL
     * @param {*} option - l'option qui doit être testée
     * @param {*} optionId - la valeur de l'option qui doit être comparée au paramètre dans l'URL
     */

    getOptionSelected: function (option, optionId) {
        if (form.urlParams.get('formation') !== null && optionId == form.urlParams.get('formation')) {
            option.selected = 'selected';
            form.formationId = form.urlParams.get('formation');
        }
        if (form.urlParams.get('ville') !== null && optionId == form.urlParams.get('ville')) {
            option.selected = 'selected';
        }
        if (form.urlParams.get('sessions') !== null && optionId == form.urlParams.get('sessions')) {
            option.selected = 'selected';
        }
    },

    /**
     * Store le formulaire sélectionné en session storage
     * @param {*} event 
     */
    setSelectedForm: function(event) {
        if (event.target) {
            sessionStorage.setItem('tab', event.target.id);
        }
    },

    /**
     * Récupère le formulaire sélectionné en session storage
     */
    getSelectedForm: function() {
        const data = sessionStorage.getItem('tab');
        if (data) {
            let input = document.getElementById(data);
            if (input) {
                input.checked = true;
            }
        }
    },

    /**
     * Remplit les champs cachés du formulaire pour les envoyer au destinataire
     * @param {*} param - Libellé du champ pour la nouvelle valeur
     * @param {*} newValue - Id de la nouvelle valeur
     */
    fillHiddenFields: function(param, newValue) {
        let hiddenFields = [];
        // Champ pour la formation sélectionnée
        hiddenFields['your-formation'] = document.querySelectorAll("[name='your-formation']");
        for (let i = 0; i < hiddenFields['your-formation'].length; ++i) {
            if (window.preInscriptionFormation != null) {
                hiddenFields['your-formation'][i].value = window.preInscriptionFormation;
            }
            if (param === 'your-formation' ) {
                hiddenFields['your-formation'][i].value = newValue;
            }
        }
        // Champ pour la ville sélectionnée
        hiddenFields['your-ville'] = document.querySelectorAll("[name='your-ville']");
        for (let i = 0; i < hiddenFields['your-ville'].length; ++i) {
            if (window.preInscriptionVille != null) {
                hiddenFields['your-ville'][i].value = window.preInscriptionVille;
            }
            if (param === 'your-ville') {
                hiddenFields['your-ville'][i].value = newValue;
            }
        }
        // Champ pour la session de formation sélectionnée
        hiddenFields['your-dates'] = document.querySelectorAll("[name='your-dates']");
        for (let i = 0; i < hiddenFields['your-dates'].length; ++i) {
            if (window.preInscriptionDates != null) {
                hiddenFields['your-dates'][i].value = window.preInscriptionDates;
            }
            if (param === 'your-dates') {
                hiddenFields['your-dates'][i].value = newValue;
            }
        }
        // Champ pour la session de formation sélectionnée
        hiddenFields['your-tarif-inter'] = document.querySelectorAll("[name='your-tarif-inter']");
        for (let i = 0; i < hiddenFields['your-tarif-inter'].length; ++i) {
            if (window.preInscriptionTarifInter != null) {
                hiddenFields['your-tarif-inter'][i].value = form.decodeHTMLEntities(window.preInscriptionTarifInter);
            }
            if (param === 'your-tarif-inter') {
                hiddenFields['your-tarif-inter'][i].value = form.decodeHTMLEntities(newValue);
            }
        }
    },

    /**
     * Gère les changements du formulaire dans le cas de changement dans les selects
     */
    handleChange: async function() {

        document.addEventListener('change', (e) => {
            if (form.elements.args.onCf7) {
                // Dans le cas du select des formations
                if  (e.target.name === "formation") {
                    form.formationId = e.target.selectedOptions[0].dataset.formation;
                    // On update le select des villes de formation
                    form.updateVilles('', form.formationId, false);
                    // On update le select des sessions de formation
                    form.updateDates(null, null);
                    // On affiche le select des villes de formation
                    form.selectVille.forEach((ville) => {
                        let parent = ville.closest('.row');
                        parent.style.display = 'block';
                    });
                    // On cache le select des sessions de formation
                    form.selectDates.forEach((selectDate) => {
                        let parent = selectDate.closest('.row');
                        parent.style.display = 'none';
                    });
                    if (e.target.value == 'default') {
                        form.selectVille.forEach((ville) => {
                            let parent = ville.closest('.row');
                            parent.style.display = 'none';
                        });
                    }
                    
                    form.fillHiddenFields('your-formation', e.target.selectedOptions[0].innerHTML);

                }
            }
            // Dans le cas du select des villes de formations
            if  (e.target.name === "centre" || e.target.name === "ville" ) {
                let optionSelected = e.target.value;
                form.ville = e.target.selectedOptions[0].dataset.ville;
                // if (e.target.name === "ville" ) {
                //     form.ville = e.target.selectedOptions[0].value;
                // }

                // Si on est sur une page du formulaire
                if (form.elements.args.onCf7) {
                    // On update le select des sessions de formation
                    form.updateDates('', optionSelected);
                    form.selectDates.forEach((selectDate) => {
                        // On affiche le select des sessions de formation
                        let parent = selectDate.closest('.row');
                        parent.style.display = 'block';
                    });
                    if (e.target.value == '' || e.target.value == 'centre' || e.target.value == 'ville') {
                        form.selectDates.forEach((date) => {
                            let parent = date.closest('.row');
                            parent.style.display = 'none';
                        });
                    }
                    form.fillHiddenFields('your-ville', e.target.selectedOptions[0].innerHTML);
                } else { // si on est sur une page de formation
                    // On update le select des sessions de formation
                    form.updateDates(optionSelected, form.ville);
                }

            }
            // Dans le cas du select des sessions de formation
            if  (e.target.name === "session") {
                let optionSelected = e.target.value;
                if (form.elements.args.onCf7) {
                    let dataVille = e.target.selectedOptions[0].dataset.ville;
                    // si on est sur une page de formation
                    if (!form.elements.args.onCf7) { 

                        // On update le select des villes de formation
                        form.updateVilles(optionSelected, dataVille);
                    }
                    form.fillHiddenFields('your-dates', e.target.selectedOptions[0].innerHTML);
                } else {
                    let dataVille = e.target.selectedOptions[0].dataset.ville;
                    let dataCentre = e.target.selectedOptions[0].dataset.centre;
                    let data = {
                        dataVille,
                        dataCentre
                    }
                    form.updateVilles(optionSelected, data);
                }
            }
        })
    },
    
    /**
     * Génère les villes de formation dans le select
     * @param {*} option - l'option dans le select
     * @param {*} newFormationId - la formation dont il faut rechercher les villes de formation
     * @param {*} fromUrl - Si la ville de formation vient d'un paramère dans l'URL
     */
    updateVilles: async function (option, newFormationId, fromUrl) {
        let nodeList = [];
        nodeList = nodeList.concat(...form.selectVille);
        if (fromUrl) {
            if (option.value != newFormationId && option.value !== "" && option.value !== "default") {
                if (form.urlParams.get('ville') && form.urlParams.get('ville') !== 'default') {
                    nodeList.forEach((node) => {
                        Array.from(node).forEach((option) => {
                            if (form.villesForFormation.includes(parseInt(form.urlParams.get('ville'))) || option.value == '' || option.value == 'default') {
                                option.style.display = 'block';
                            } else {
                                option.style.display = 'none';
    
                            }
                        });
                    })
                } else {
                    option.style.display = 'block';
                    form.selectDates.forEach((selectDate) => {
                        let parent = selectDate.closest('.row');
                        parent.style.display = 'none';
                    });
                }
            } else {
                option.style.display = 'block';
            }
        } else {
            if (form.elements.args.onCf7) {
                form.villesForFormation = [];
                form.formations.forEach((formation) => {
                    if(formation.id == newFormationId) {
                        if (formation.acf.sessions) {
                            formation.acf.sessions.forEach((date) => {
                                form.villesForFormation.push(date.ville);
                            });
                        }
                    }
                })

                form.selectVille.forEach((selectElement) => {
                    selectElement.options.length = 0;
                    
                    let option = document.createElement('option');
                    option.value = '';
                    option.text = 'Veuillez choisir une ville de formation';
                    if (form.villesForFormation.length == 0) {
                        option.value = 'default';
                        option.text = 'Pas de ville pour cette formation';
                    }
                    selectElement.add(option);
                    
                    // Ajout des options correspondant aux villes de formation
                    form.centres.forEach((element) => {
                        if (element && element.title && element.title.rendered) {
                            let option = document.createElement('option');
                            option.value = element.id;
                            option.text = form.decodeHTMLEntities(element.title.rendered);
                            selectElement.add(option);
                            form.getOptionSelected(option, option.value);
                        }
                    });
                    Array.from(selectElement.options).forEach((option) => {
                        if (form.villesForFormation.includes(parseInt(option.value)) || option.value == '' || option.value == 'default') {
                            option.style.display = 'block';
                        } else {
                            option.style.display = 'none';
                        }
                    });
                    selectElement.selectedIndex = 0;
                });
            } else {
                for (let i = 0; i < form.selectVille.options.length; i++) {
                    form.selectVille.options[i].classList.remove('date-available');
                    if (option == "" || option == "default") {
                        form.selectVille.options[i].disabled = false;
                        form.selectVille.selectedIndex = 0;
                    } else {
                        if (form.selectVille.options[i].dataset.ville !== newFormationId.dataVille && form.selectVille.options[i].dataset.ville !== "default") {
                            form.selectVille.options[i].disabled = true;
                        } else {
                            form.selectVille.selectedIndex = i;
                            form.selectVille.options[i].disabled = false;
                            if (newFormationId.dataVille == form.selectVille.options[i].dataset.ville) {
                                form.selectVille.options[i].value = newFormationId.dataCentre;
                            } else {
                                form.selectVille.options[i].disabled = true;
                            }
                        }
                    }
                    
                }
            }

        }
    },

    /**
     * Génère les sessions de formation dans le select
     * @param {*} option - l'option dans le select
     * @param {*} newVilleId - la ville de formation dont il faut rechercher les sessions de formation
     * @param {*} fromUrl - Si la ville de formation vient d'un paramère dans l'URL
     */
    updateDates: async function (option, newVilleId, fromUrl = false) {
        let datesForFormation = [];

        // Si on est sur un formulaire et qu'il n'y a pas de centre de formation en paramètre de l'URL
        if (!newVilleId && form.elements.args.onCf7) {
            form.selectDates.forEach((selectElement) => {
                selectElement.length = 0;
                option = document.createElement('option');
                option.value = '';
                option.text = 'Veuillez choisir une session de formation';
                if (datesForFormation.length == 0) {
                    option.value = 'default';
                    option.text = 'Demander une nouvelle date';
                }
                selectElement.add(option);
            });
        } else {
            
            // Si on est sur un formulaire
            if (form.selectDates instanceof NodeList) { 
                form.formations.forEach((formation) => {
                    if(formation.id == form.formationId) {
                        if (formation.acf.sessions) {
                            formation.acf.sessions.forEach((date) => {
                                if (date.ville == newVilleId) {
                                    // On récupère les dates de formations qui correspondent au nouveau centre sélectionné
                                    datesForFormation.push(
                                        {
                                            'id' : newVilleId,
                                            'date_de_debut' : date.date_de_debut, 
                                            'date_de_fin' : date.date_de_fin,
                                            'effectif_prevu' : date.effectif_prevu
                                        }
                                    )
                                }
                            });
                        }
                    }
                })
        
                // On créé les options pour les select des sessions de formation
                form.selectDates.forEach((selectElement) => {
                    // On créé le select par défaut
                    selectElement.style.display = 'block';
                    selectElement.length = 0;
                    let option = document.createElement('option');
                    option.value = '';
                    option.text = 'Veuillez choisir une session de formation';
                    if (datesForFormation.length == 0) {
                        option.value = 'default';
                        option.text = 'Demander une nouvelle date';
                    }
                    selectElement.add(option);
                    Array.from(datesForFormation).forEach((date) => {
                        let option = document.createElement('option');
                        // Si il n'y a pas de date de début ou de fin de session, on avertit l'utilisateur
                        if (!date.date_de_debut || !date.date_de_fin) {
                            selectElement.options[0].text = "Demander une nouvelle date";
                            selectElement.selectedIndex = 0;
                            return;
                        } else {
                                // Sinon on créé les options de sessions de formation
                                option.value = date.date_de_debut + date.date_de_fin;
                                let pluriel = date.effectif_prevu > 1 ? 's' : '';
                                let effectifPrevu = date.effectif_prevu
                                    ? ' [' + date.effectif_prevu + ' place' + pluriel + ']'
                                    : '';
                
                                option.text = "Du " +
                                    form.formatDate(date.date_de_debut) +
                                    " au " +
                                    form.formatDate(date.date_de_fin) +
                                    effectifPrevu;
                                if (fromUrl ) {
                                    option.selected = true;
                                    form.fillHiddenFields('your-dates',  option.innerHTML);
                                }
                            }
                            selectElement.add(option);
                        });
                    // Si il n'y a pas de paramètre dans l'URL, on sélectionne l'option par défaut
                    if (!fromUrl) {
                        selectElement.selectedIndex = 0;
                    } else {
                        // Sinon on selectionne la bonne option
                        selectElement.selectedIndex = parseInt(form.urlParams.get('sessions'));
                    }
                });
            } else {
                
                // Si le paramètre dans l'URL est autre, on cache le select des sessions de formation
                if (newVilleId == 'autre') {
                    form.selectDates.style.display = 'none';
                } else {
                    // Sinon on l'affiche
                    form.selectDates.style.display = 'block';
                }
                if (option == "default") {
                    for (let opt of form.selectDates.options) {
                        opt.style.display = 'block';
                    }
                    for (let opt of form.selectVille.options) {
                        opt.display = 'block';
                    }
                } else if (option === 'autre') {
                    form.selectDates.style.display = 'none';
                } else {
                    if (form.selectDates.selectedIndex !== 0) {
                        form.selectDates.selectedIndex = 0;
                    }
                    for (let opt of form.selectDates.options) {
                        opt.style.display = 'block';
                        let condition = opt.dataset.ville !== newVilleId && opt.dataset.ville !== "default" && opt.dataset.ville !== "autre";
                        if (form.elements.onCf7) {
                            condition = form.selectFormation.value === newVilleId;
                        }
                        if (condition) {
                            opt.style.display = 'none';
                        } else if(newVilleId == 'default' || newVilleId == 'autre') {
                            opt.style.display = 'block';
                        } else {
                            opt.style.display = 'block';
                        }
                    }
                }
            }
        }
        
    },

    /**
     * Retourne du texte formaté
     * @param {*} str - Texte récupéré dans JSON
     * @returns 
     */
    decodeHTMLEntities: function(str) {
        const txt = document.createElement('textarea');
        txt.innerHTML = str;
        return txt.value;
    },

    /**
     * Toggle entre tarif inter et tarif intra dans le header la page formation 
     */
    changeTarif: function() {
        const radios = document.querySelectorAll('input[name="tab-control"]');
        const blocInter = document.getElementById('tarif_inter');
        const blocIntra = document.getElementById('tarif_intra');
      
        radios.forEach(radio => {
          radio.addEventListener('change', () => {
            if (radio.id === 'tab2' && radio.checked) {
              blocIntra.style.display = 'block';
              blocInter.style.display = 'none';
            } else {
              blocIntra.style.display = 'none';
              blocInter.style.display = 'block';
            }
          });
        });
    }


};

document.addEventListener('DOMContentLoaded', form.init);